var modules_0b64ef5e = {"container":"_hbfrhl","fullscreen":"_19ns30b","overlay":"_1hn247b","backdrop":"_5dl3st","header":"_1svwzx","content":"_l1qud6","footer":"_7zoos2","title":"_18sxjrv","title-wrapper":"_etdtt9","subtitle":"_czvphw","close":"_du9frf","divider":"_otkq4e","auxiliary-layer":"_b0pk1c"};
import "../../../assets/mIiwn_Z9.css";

export { modules_0b64ef5e as default };
//# sourceMappingURL=Sheet.module.less.js.map
